export type SortByValue =
  "price-low-to-high" | "price-high-to-low" | "name-asc" | "name-desc" | "newest-first" | "expiring-soon";

export type SortByItemDefinition = {
  value: SortByValue;
  displayName: string;
};
